/**
 * Generato automaticamente.
 * framework-cmp-domande
 */

export type GetFrontNotificheSortDirection =
  (typeof GetFrontNotificheSortDirection)[keyof typeof GetFrontNotificheSortDirection];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetFrontNotificheSortDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;
